module.exports = __webpack_public_path__ + "img/ivancik.cae2ea81.jpg";